import { cn } from "@/domains/library"

import { NotificationPosition } from "../settings-store"

export const PositionGrid = ({ position, selected }: { position: NotificationPosition; selected: boolean }) => {
  const currentColor = "text-t300 fill-p300"
  const selectedColor = "text-t100 fill-p100"
  const borderColor = "stroke-p300"
  const selectedBorderColor = "stroke-p100"
  const clipId = `clip-${Math.random().toString(36).substr(2, 9)}`

  const notificationBorderRadius = 4

  return (
    <svg width="64" height="64" viewBox="0 0 100 100" className={currentColor}>
      <defs>
        <clipPath id={clipId}>
          <rect x="1" y="1" width="98" height="98" rx="8" ry="8" />
        </clipPath>
      </defs>

      {/* Grid lines */}
      {/* <line x1="1" y1="25" x2="99" y2="25" stroke="currentColor" strokeWidth="1" className="opacity-50" />
      <line x1="1" y1="50" x2="99" y2="50" stroke="currentColor" strokeWidth="1" className="opacity-50" />
      <line x1="1" y1="75" x2="99" y2="75" stroke="currentColor" strokeWidth="1" className="opacity-50" />
      <line x1="25" y1="1" x2="25" y2="99" stroke="currentColor" strokeWidth="1" className="opacity-50" />
      <line x1="50" y1="1" x2="50" y2="99" stroke="currentColor" strokeWidth="1" className="opacity-50" />
      <line x1="75" y1="1" x2="75" y2="99" stroke="currentColor" strokeWidth="1" className="opacity-50" /> */}

      {/* Position-specific filled rectangles */}
      <g clipPath={`url(#${clipId})`}>
        {position === "bottom-left" && (
          <rect
            x="7"
            y="63"
            width="54"
            height="30"
            rx={notificationBorderRadius}
            ry={notificationBorderRadius}
            className={selected ? selectedColor : currentColor}
          />
        )}
        {position === "top-left" && (
          <rect
            x="7"
            y="7"
            width="54"
            height="30"
            rx={notificationBorderRadius}
            ry={notificationBorderRadius}
            className={selected ? selectedColor : currentColor}
          />
        )}
        {position === "top-right" && (
          <rect
            x="39"
            y="7"
            width="54"
            height="30"
            rx={notificationBorderRadius}
            ry={notificationBorderRadius}
            className={selected ? selectedColor : currentColor}
          />
        )}

        {position === "bottom-right" && (
          <rect
            x="39"
            y="63"
            width="54"
            height="30"
            rx={notificationBorderRadius}
            ry={notificationBorderRadius}
            className={selected ? selectedColor : currentColor}
          />
        )}
      </g>

      {/* Border with rounded corners using rx attribute */}
      <rect
        x="1"
        y="1"
        width="98"
        height="98"
        rx="8"
        ry="8"
        fill="none"
        className={selected ? selectedBorderColor : borderColor}
        strokeWidth="1"
      />
    </svg>
  )
}
